import _axios from "../axios";
import { AccountContext } from "../contexts/AccountContext";
import { useContext } from "react";
import {FaTrash } from "react-icons/fa";
import PointsLoader from "../components/PointsLoader";
import useDeviceSize from "../components/useDeviceSize";
import UserSidebar from "../components/UserSidebar";
import UserSidebarMobile from "../components/UserSidebarMobile";
import buildLink from "../urls";
import { Helmet } from "react-helmet";
import React, { useEffect, useState } from "react";
import { AiOutlineCheck } from "react-icons/ai";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import StarRating from "react-svg-star-rating";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import StarRatings from "react-star-ratings";

function Feedback() {
  const [width] = useDeviceSize();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [required, setRequired] = useState("");
  const [success, setSucess] = useState("");
  const [activeService, setActiveService] = useState(0);
  const [showSubmitBtn, setShowSubmitBtn] = useState(false);
  const [feedbacks, setFeedbacks] = useState([]);
  const [state, dispatch] = useContext(AccountContext);
  const router = useNavigate();
  const [showPointsPopup,setShowPointsPopup] = useState(false)
  const [earnedPoints, setEarnedPoints] = useState(0); 
  const [isLargeScreen, setIsLargeScreen] = useState(false);


  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsLargeScreen(width >= 1024);
    };

    window.addEventListener("resize", checkScreenSize);
    checkScreenSize(); 

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);


  useEffect(() => {
    if (!state.loading && !state.loged) {
      router.push("/");
    } else if (state.loged) {
      _axios
        .get(buildLink("getcustomerfeedback", undefined, window.innerWidth))
        .then((response) => {
          const data = response.data.data;
          setData(data);
          const feedbacksData = response.data.data.map((service) => ({
            service_id: !service.is_general ? service.service_id : "general",
            rating: !service.is_general ? service.rate : "",
            comment: !service.is_general
              ? service.service_comment
              : service.comment,
          }));
          setFeedbacks(feedbacksData);
          setLoading(false);
        });
    }
  }, [state.loading]);

  function handleActiveService(operation) {
    if (operation === "inc") {
      setActiveService(activeService + 1);
      if (activeService === data.length - 2) {
        setShowSubmitBtn(true);
      }
    } else {
      setActiveService(activeService - 1);
      if (activeService !== data.length - 2) {
        setShowSubmitBtn(false);
      }
    }
  }

  function handleSubmit() {
    setRequired("");
    setSucess("");
    var obj = {
      data: [],
    };
    const generalFeedback = feedbacks.find(
      (feedback) => feedback.service_id === "general"
    );
    if (generalFeedback.comment === "") {
      setRequired("General Feedback is required!");
    } else {
      obj["data"][0] = {
        comment: generalFeedback.comment,
        src: "",
        version_number: "",
      };
      for (let index = 1; index < data.length; index++) {
        const feedback = feedbacks[index];
        obj["data"][index] = {
          serveice_id: feedback.service_id, //maktube ghalat mn l backend
          service_comment: feedback.comment,
          rate: feedback.rating,
        };
      }
      _axios
        .put(
          buildLink("editcustomerfeedback", undefined, window.innerWidth),
          obj
        )
        .then((response) => {
          if (response.data.success) {
            toast(response.data.message, { type: "success" });
            setActiveService(activeService - 2);
            setShowSubmitBtn(false);
            if(response?.data?.data?.points_gained > 0){
              setShowPointsPopup(true)
              setEarnedPoints(response?.data?.data?.points_gained)
            }
          }
          else{
            toast("Feedback Updated", { type: "success" });
             setActiveService(activeService - 2);
             setShowSubmitBtn(false);

          }
        });
    }
  }

  function handleStarRatingChange(service_id, rating) {
    const updatedFeedbacks = feedbacks.map((feedback) => {
      if (feedback.service_id === service_id) {
        return { ...feedback, rating };
      }
      return feedback;
    });
    setFeedbacks(updatedFeedbacks);
  }

  const handleCommentChange = (service_id, event) => {
    const updatedFeedbacks = feedbacks.map((feedback) => {
      if (feedback.service_id === service_id) {
        return { ...feedback, comment: event.target.value };
      }
      return feedback;
    });
    setFeedbacks(updatedFeedbacks);
  };

  return (
    <div className=" text-dblack">
      <head>
        <title>My Account | ishtari</title>
      </head>
      <div className="pb-2">
        <div className="flex-row md:flex">
        <div className={`w-full mb-4 md:w-[25%]  -ml-3 ${width <= 650 ? 'hidden' : ''}`}>
            <UserSidebar active={"feedback"} />
          </div>
          <div className="w-full   mb-5">
            {loading ? (
              <div className="flex justify-center w-full">
                <PointsLoader />
              </div>
            ) : (
              <div className="w-full flex flex-col gap-10">
                <div className="relative flex justify-center">
                  <div className="banner-image w-full flex justify-center">
                  <img
                      src={require("../assets/images/feedback-website.png")}
                      width={1100}
                      height={200}
                      className="w-full hidden md:block cursor-pointer"
                      alt="feedback_banner"
                    />
                    <img
                      src={require("../assets/images/feedback-website.png")}
                      width={1100}
                      height={200}
                      className="w-full md:hidden"
                      alt="feedback_banner_mobile"
                    />
                  </div>
                  {data?.map((service, i) => (
                    <div
                      className={`starts-div absolute z-10 rounded-lg bg-white text-dgreyProduct text-sm md:text-d18 shadow-md italic px-6 py-1.5 -bottom-4 ${
                        activeService === i ? "" : "hidden"
                      }`}
                      key={i}
                    >
                      {service.is_general ? (
                        <div className="">We appreciate your feedback</div>
                      ) : (
                        <div>
                          <StarRatings
                            starDimension="24px"
                            starSpacing="1px"
                            isSelectable="true"
                            containerClassName="flex mr-2"
                            starEmptyColor="#e3e3e3"
                            starRatedColor="#f5a523"
                            starHoverColor="#f5a523"
                            rating={parseFloat(
                              feedbacks.find(
                                (feedback) =>
                                  feedback.service_id === service.service_id
                              )?.rating || 0
                            )}
                            changeRating={(rating) =>
                              handleStarRatingChange(service.service_id, rating)
                            }
                          />
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                {required.length > 0 && (
                  <div className="alert rounded-md text-dbase  text-d20 text-center">
                    {required}
                  </div>
                )}

                {data?.map((service, i) => (
                  <div
                    className={`mt-7 flex flex-col justify-center items-center gap-5 ${
                      activeService === i ? "" : "hidden"
                    }`}
                    key={i}
                  >
                    <div className=" pr-semibold text-d20">
                      {service.is_general ? (
                        <div>General Feedback</div>
                      ) : (
                        <div>{service.service_name}</div>
                      )}
                    </div>

                    <textarea
                      id={`feedback${i}`}
                      className="w-11/12 md:w-3/4 h-44 rounded-lg shadow-lg p-5 text-sm"
                      placeholder="There is no failure. Only feedback."
                      defaultValue={
                        service.is_general
                          ? service.comment
                          : service.service_comment
                      }
                      onChange={(e) =>
                        handleCommentChange(
                          !service.is_general ? service.service_id : "general",
                          e
                        )
                      }
                    ></textarea>
                     <button
                    type="button"
                    style={{transform:isLargeScreen?"translate(2300%,-1060%)":"translate(800%,-1070%)"}}
                    onClick={() => {
                      document.getElementById(`feedback${i}`).value = "";
                    }}
                  >
                    <FaTrash/>
                  </button>
                  </div>
                ))}

                <div className="service-pagination flex w-full justify-center gap-5 mt-10">
                  <div
                    className={`arrow-left rounded-lg shadow-md bg-white p-3 cursor-pointer ${
                      activeService === 0 ? "hidden" : ""
                    }`}
                    onClick={() => handleActiveService("dec")}
                  >
                    <BsArrowLeft className="w-6 h-6" />
                  </div>

                  <div
                    className={`arrow-left-hidden bg-transparent p-3 cursor-pointer w-12 ${
                      activeService === 0 ? "" : "hidden"
                    }`}
                  ></div>

                  <div className="page-nb bg-white rounded-lg shadow-md p-3 w-24 text-center text-d18">
                    {activeService + 1}
                  </div>
                  <div
                    className={`arrow-right rounded-lg shadow-md bg-white p-3 cursor-pointer ${
                      showSubmitBtn ? "hidden" : ""
                    }`}
                    onClick={() => handleActiveService("inc")}
                  >
                    <BsArrowRight className="w-6 h-6" />
                  </div>
                  <div
                    className={`submit-btn rounded-lg shadow-md bg-white p-3 cursor-pointer ${
                      showSubmitBtn ? "" : "hidden"
                    }`}
                    onClick={() => handleSubmit()}
                  >
                    <AiOutlineCheck className="w-6 h-6" />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {showPointsPopup && (
        <div
          onClick={() => setShowPointsPopup(false)}
          className=" fixed left-0 top-0 right-0 bottom-0  bg-dblack bg-opacity-40 z-50 "
        ></div>
      )}
      {showPointsPopup && (
        <div
          className={` " top-0  scale-100 opacity-100"
         
          } z-50 fixed px-5   rounded-md max-md:w-[350px] max-md:h-[300px] left-0 top-0 bottom-0 py-5 right-0  transition-opacity duration-300 bg-white my-auto mx-auto w-[450px] h-[250px]`}
        >
          <div className=" w-full h-full relative justify-center text-center flex flex-col gap-4">
            <div className=" w-16 h-16  mx-auto   bg-dbase text-white rounded-full flex items-center justify-center">
              <span className=" text-2xl">+{earnedPoints}</span>
            </div>
            <h2 className=" text-2xl font-bold">
              You've earned{" "}
              <span className=" text-dbase  font-extrabold">{earnedPoints}</span>{" "}
              points!
            </h2>
            <button
              onClick={() => setShowPointsPopup(false)}
              className="  bg-dbase mt-4 text-white px-4 py-1 rounded-md text-xl"
            >
              Confirm
            </button>
          </div>
        </div>
      )}


    </div>
  );
}

export default Feedback;
